import { CustomFabricImage } from '../../../global-types/canvas';
import { CanvasDataTypes } from '../../../utils/canvas-utils/canvas-data-types';
import { getIconForLowResImage } from '../../../utils/canvas-utils/get-icon-for-low-res-image';
import { validateImagePpi } from '../../../utils/canvas-utils/validate-image-ppi';
import { addPhotozoneImageMoveConstraint } from './add-photozone-image-move-constraint';

type ScalePhotoParams = {
  photo: CustomFabricImage;
  scaleFactor: number;
  canvas: fabric.Canvas;
  originalScale: { x: number | undefined; y: number | undefined };
  isFront: boolean;
  isForceFillEnabled?: boolean;
};

export const scalePhoto = ({
  photo,
  scaleFactor,
  canvas,
  originalScale,
  isFront,
  isForceFillEnabled,
}: ScalePhotoParams) => {
  photo.set({
    scaleX: scaleFactor * (originalScale?.x ?? 1), // we multiply with the original scale to maintain aspect ratio
    scaleY: scaleFactor * (originalScale?.y ?? 1),
  });

  // Check if the active object has a photozone and update its icon visibility
  const photoZoneId = photo.data?.photoZoneId;
  if (photoZoneId) {
    // Find the icon associated with this image in the photozone
    const photoZoneIcon = canvas
      .getObjects()
      .find((obj) => obj.data?.type === CanvasDataTypes.PhotoIcon && obj.data?.parentName === photo.name);
    if (photoZoneIcon) {
      photoZoneIcon.visible = !validateImagePpi(photo);
    }
  } else {
    // get low res icon object for photo
    const lowResIcon = getIconForLowResImage(canvas, photo);
    if (lowResIcon) {
      // update icon visibility based on validateImagePpi
      lowResIcon.visible = !validateImagePpi(photo);
    }
  }

  if (isForceFillEnabled) {
    const canvasObjects = canvas?.getObjects() ?? [];
    const currentPhotozoneObject = canvasObjects.find((object) => object.name === photo.data.photoZoneId);
    if (currentPhotozoneObject && isFront) {
      addPhotozoneImageMoveConstraint(photo, currentPhotozoneObject).onCallback();
    }
  }

  canvas.renderAll();
};
